// extracted by mini-css-extract-plugin
module.exports =  {"container":"a10a3f92e9--container--LFx0W","text-wrapper":"a10a3f92e9--text-wrapper--ZbeUI","icon-wrapper":"a10a3f92e9--icon-wrapper--fdDXF","title":"a10a3f92e9--title--yD7ir"};